
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import userx from '@/store/modules/userx';
import schemax from '@/store/modules/schemax';

import {
	ExtractorItem,
	ExtractorSchema,
	ExtratorConvertPair,
} from '@/store/models.def';
import uuid from 'uuid';

const ID = 0;
const OPERATOR = 1;
const FROM = 2;
const SCHEMA = 2;
const PAIRS = 3;

@Component({
	components: {
		ExtractorSchemaComponent: () => import('./ExtractorSchema.vue'),
	},
})
export default class ExtractorItemComponent extends Vue {
	public get operators() {
		return ['EQUAL', 'JOIN', 'CONVERT', 'DATE'];
	}
	@Prop({ default: [uuid.v4(), 'EQUAL', ''] }) public value!: ExtractorItem;

	public id: string = '';
	public operator: 'EQUAL' | 'JOIN' | 'CONVERT' | 'DATE' = 'EQUAL';
	public from: string = '';
	public convertPairs: string[][] = [['', '', uuid.v4()]];
	public schema: ExtractorSchema = { '': [uuid.v4(), 'EQUAL', ''] };

	@Watch('value')
	public onValueChanged(val: ExtractorItem, oldVal: ExtractorItem) {
		if (val !== null) {
			this.setProp(val);
			const result = this._validfy();
			if (result === null) {
				this.$emit('input', null);
			}
		}
	}

	public mounted() {
		let result = null;
		if (this.value) {
			this.setProp(this.value);
			result = this._validfy();
		}
		if (result === null) {
			this.$emit('input', null);
		}
	}

	public setProp(val: ExtractorItem) {
		this.id = val[ID];
		this.operator = val[OPERATOR];
		if (this.operator === 'EQUAL') {
			this.from = val[FROM] as string;
		} else if (this.operator === 'CONVERT') {
			this.from = val[FROM] as string;
			if (Array.isArray(val[PAIRS])) {
				this.convertPairs = (val[PAIRS] as ExtratorConvertPair[]).map((pair) =>
					this.dataToStringConvertPair(pair),
				);
			}
		} else if (this.operator === 'JOIN') {
			this.schema = val[SCHEMA] as ExtractorSchema;
		} else if (this.operator === 'DATE') {
			this.from = val[FROM] as string;
		}
	}

	public validateField(str: string) {
		return str.length >= 1;
	}
	public validateConvertPair(val: any) {
		// only allow true, false, null, number and value with '' or ""
		return /(^false$)|(^true$)|(^null$)|(^-?\d+\.?\d*$)|(^['"][^'"]+['"]$)/.test(
			val,
		);
	}
	public dataToStringConvertPair(pair: ExtratorConvertPair) {
		return [convert(pair[0]), convert(pair[1]), pair[2]];
		function convert(data: string | number | boolean | null) {
			if (data !== '' && typeof data === 'string') {
				return `'${data}'`;
			}
			if (typeof data === 'number') {
				return data.toString();
			}
			if (typeof data === 'boolean') {
				return data.toString();
			}
			if (typeof data === null) {
				return 'null';
			}
			return '';
		}
	}
	public stringToDataConvertPair(pair: string[]): ExtratorConvertPair {
		return [convert(pair[0]), convert(pair[1]), pair[2]];
		function convert(str: string) {
			switch (str) {
				case 'false':
					return false;
					break;
				case 'true':
					return true;
					break;
				case 'null':
					return null;
					break;
				default:
					if (/(^-?\d+\.?\d*$)/.test(str)) {
						return Number(str);
					} else if (/(^['"][^'"]+['"]$)/.test(str)) {
						return str.substring(1, str.length - 1);
					} else {
						return str;
					}
					break;
			}
		}
	}

	public addConvertPair() {
		this.convertPairs.push(['', '', uuid.v4()]);
	}
	public removePair(id: string) {
		this.convertPairs = this.convertPairs.filter((pair) => pair[2] !== id);
		if (this.convertPairs.length === 0) {
			this.convertPairs.push(['', '', uuid.v4()]);
		}
		this._onInput();
	}

	protected _onInput() {
		this.$emit('input', this._validfy());
	}
	protected _validfy() {
		const result: ExtractorItem = [this.id, this.operator, ''];

		if (
			this.operator !== 'EQUAL' &&
			this.operator !== 'JOIN' &&
			this.operator !== 'DATE' &&
			this.operator !== 'CONVERT'
		) {
			return null;
		}
		if (this.operator === 'EQUAL' || this.operator === 'CONVERT' || this.operator === 'DATE') {
			if (!this.from || typeof this.from !== 'string') {
				return null;
			}
			result[FROM] = this.from;
		}

		if (this.operator === 'CONVERT') {
			if (!Array.isArray(this.convertPairs) || this.convertPairs.length === 0) {
				return null;
			}
			const pairs = [];

			for (const pair of this.convertPairs) {
				if (pair.length !== 3) {
					return null;
				}
				if (!this.validateConvertPair(pair[0])) {
					return null;
				}
				if (!this.validateConvertPair(pair[1])) {
					return null;
				}
				pairs.push(this.stringToDataConvertPair(pair));
			}
			result[PAIRS] = pairs;
		} else if (this.operator === 'JOIN') {
			if (!this.schema) {
				return null;
			}
			result[SCHEMA] = this.schema;
		}
		return result;
	}
}
